module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAA3ElEQVRYR+2YsQ3CMBBF/4UdUGjAHXTQQpagYg5YABDjsEd66KDC0IQpcsgiBVWM9F24OLen/3V+/vJZFpCrHFcbKXAKNtpi/37VZ8ZSGHHQjlx1AzDtfO6Nr2eMZ4qG9LeBxteUJyXuCFlDvZEYucoIGSHm2gj3kGXIMmQZ6iOQ3ywbuuV6ADkAsqDOjhQr1LfQnZRu9RCII/0SyfUSGvICmSRyZG2u8j2y4ghgzroxeoU+W+g2v1Azu7IX4z/0bNrHKBkhIxQjEKtbhoxQjECsnmOG8vqwSv2l9wFD5pspHnIIXAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/open.png
// module id = GAzZ
// module chunks = 1